import { Routes } from '@angular/router';
import { DashboardComponent } from './views/common/dashboard/dashboard.component';
import { MasterSearchComponent } from './master-search-group/master-search/master-search.component';
import { LoginComponent } from './views/login/login.component';
import { CreateAccountComponent } from './views/create-account/create-account.component';
import { ResetPasswordComponent } from './views/reset-password/reset-password.component';
import { ManageUserComponent } from './views/common/manage-user/manage-user.component';
// import { PersonalInformationComponent } from './personal-information/personal-information.component';
import { UpdateMemberComponent } from './update-member/update-member.component';
import { RequestMapper } from './request-mapper';
import { PrintMonitorComponent } from './print-monitor/print-monitor.component';
import { DpSideNavComponent } from './views/common/dp-side-nav/dp-side-nav.component';
import { authGuard } from './guard/auth.guard';
import { ReviewDataComponent } from './review-data-group/review-data/review-data.component';
import { NamesToUpdateComponent } from './names-to-update/names-to-update.component';
import { DpnfComponent } from './views/common/dpnf/dpnf.component';
import { CreateAccountVerificationComponent } from './views/create-account/create-account-verification/create-account-verification.component';
import { LoginVerifyComponent } from './views/login/login-verify/login-verify.component';
import { LoginRoleMergeComponent } from './views/login/login-role-merge/login-role-merge.component';
import { LoginEmailAuthCodeComponent } from './views/login/login-email-auth-code/login-email-auth-code.component';
import { UnsavedChangesGuard } from './guard/unsaved-changes.guard';
import { FcMergeComponent } from './fc-merge/fc-merge.component';
import { DpProfileComponent } from './common-component/dp-profile/dp-profile.component';
// import { AllWishlistComponent } from './all-wishlist/all-wishlist.component';
import { WorkHistoryMainComponent } from './work-history-main/work-history-main.component';
import { FindDetailsMainComponent } from './find-details/find-details-main/find-details-main.component';
import { ReachDefaulterMainComponent } from './reach-defaulter/reach-defaulter-main/reach-defaulter-main.component';
import { OblateDataComponent } from './oblate-data/oblate-data.component';
import { PointOfContactComponent } from './views/common/point-of-contact/point-of-contact.component'
import { DpSpReceivingComponent } from './dp-sp-receiving/dp-sp-receiving.component';
import { Dp10Component } from './dp1.0/dp1.0.component';
import { OblateRegisterComponent } from './oblate-register/oblate-register.component';
import { Dp40Component } from './dp4.0/dp4.0.component';
import { RitwikiComponent } from './ritwiki/ritwiki.component';
import { PanjaDetailsComponent } from './views/common/panja-details/panja-details.component';
import { Dp1OReportComponent } from './views/common/dashboard/dp-1-o-report/dp-1-o-report.component';
import { RitwikReportComponent } from './views/common/dashboard/ritwik-report/ritwik-report.component';
import { SettlementViewComponent } from './views/settlement-view/settlement-view.component';
import { UserActivityReportComponent } from './views/common/dashboard/user-activity-report/user-activity-report.component';
// let WORK_UPDATE_ROUTER: any;
// let role = localStorage.getItem('role');
// if (role == 'DISTRICT ADMIN') {
//   WORK_UPDATE_ROUTER = RequestMapper.WORK_UPDATE_HISTORY_DA;
// } else {
//   WORK_UPDATE_ROUTER = RequestMapper.WORK_UPDATE_HISTORY;
// }

export const routes: Routes = [
  { path: '', redirectTo: '/login', pathMatch: 'full' },
  {
    path: '',
    component: DpSideNavComponent,
    children: [
      {
        path: RequestMapper.PAGE_NOT_FOUND,
        loadComponent: () =>
          import('./page-not-found/page-not-found.component').then(
            (c) => c.PageNotFoundComponent
          ),
        canActivate: [authGuard],
      },
      { path: RequestMapper.DP_1_0, component: Dp10Component },
      {
        path: RequestMapper.UNAUTHORIZED_ACCESS,
        loadComponent: () =>
          import('./unauthorized/unauthorized.component').then(
            (c) => c.UnauthorizedComponent
          ),
        canActivate: [authGuard],
      },
      {
        path: RequestMapper.UPDATE + '/:memId',
        loadComponent: () =>
          import('./personal-information/personal-information.component').then(
            (c) => c.PersonalInformationComponent
          ),
        canActivate: [authGuard],
      },
      {
        path: RequestMapper.MY_STATS,
        loadComponent: () =>
          import('./views/common/dashboard/my-stats/my-stats.component').then(
            (c) => c.MyStatsComponent
          ),
        canActivate: [authGuard],
      },
      // { path: RequestMapper.ALL_COUNTRIES, component: PrintMonitorComponent },
      // {
      //   path: RequestMapper.ALL_COUNTRIES + '/' + RequestMapper.INDIA,
      //   component: PrintMonitorComponent,
      // },
      // { path: 'all-countries/India/:state', component: PrintMonitorComponent },
      // {
      //   path:
      //     RequestMapper.ALL_COUNTRIES +
      //     '/' +
      //     RequestMapper.INDIA +
      //     '/:state' +
      //     '/:district',
      //   component: PrintMonitorComponent,
      // },
      // {
      //   path:
      //     RequestMapper.ALL_COUNTRIES +
      //     '/' +
      //     RequestMapper.INDIA +
      //     '/:state' +
      //     '/:district/show-data',
      //   component: PrintMonitorComponent,
      // },
      // {
      //   path:
      //     RequestMapper.ALL_COUNTRIES +
      //     '/' +
      //     RequestMapper.INDIA +
      //     '/:state' +
      //     '/:district' +
      //     '/:pincode',
      //   component: PrintMonitorComponent,
      // },
      // {
      //   path:
      //     RequestMapper.ALL_COUNTRIES +
      //     '/' +
      //     RequestMapper.INDIA +
      //     '/:state' +
      //     '/:district' +
      //     '/:pincode/show-data',
      //   component: PrintMonitorComponent,
      // },
      {
        path: RequestMapper.DASHBOARD,
        component: DashboardComponent,
        canActivate: [authGuard],
        children: [
          // {
          //   path: '',
          //   redirectTo: RequestMapper.DASHBOARD_ALL_REPORTS,
          //   pathMatch: 'full',
          // },

          {
            path: RequestMapper.DASHBOARD_ALL_REPORTS,
            loadComponent: () =>
              import('./views/common/dashboard/all-reports-dashboard/all-reports-dashboard.component').then(
                (c) => c.AllReportsDashboardComponent
              ),
          },
          {
            path: RequestMapper.DASHBOARD_USER_REPORT,
            loadComponent: () =>
              import('./views/common/dashboard/user-wise-report/user-wise-report.component').then(
                (c) => c.UserWiseReportComponent
              ),
          },
          {
            path: RequestMapper.OBLATE_STATISTICS,
            loadComponent: () =>
              import('./views/common/dashboard/oblate-statistics-report/oblate-statistics-report.component').then(
                (c) => c.OblateStatisticsReportComponent
              ),
          },
          {
            path: RequestMapper.WORKER_INFO_REPORT,
            loadComponent: () =>
              import('./views/common/dashboard/worker-info-report/worker-info-report.component').then(
                (c) => c.WorkerInfoReportComponent
              ),
          },
          {
            path: RequestMapper.MY_STATS,
            loadComponent: () =>
              import('./views/common/dashboard/my-stats/my-stats.component').then(
                (c) => c.MyStatsComponent
              ),
          },
          {
            path: RequestMapper.DASHBOARD_PHASE_ONE_REPORTS,
            loadComponent: () =>
              import('./views/common/dashboard/phase-one-report/phase-one-report.component').then(
                (c) => c.PhaseOneReportComponent
              ),
          },
          {
            path: RequestMapper.DASHBOARD_PHASE_THREE_REPORTS,
            loadComponent: () =>
              import('./views/common/dashboard/phase-three-report/phase-three-report.component').then(
                (c) => c.PhaseThreeReportComponent
              ),
          },
          {
            path: RequestMapper.DASHBOARD_PHASE_TWO_REPORTS,
            loadComponent: () =>
              import('./views/common/dashboard/phase-two-report/phase-two-report.component').then(
                (c) => c.PhaseTwoReportComponent
              ),
          },
          {
            path: RequestMapper.DASHBOARD_REACH_REPORT,
            loadComponent: () =>
              import('./views/common/dashboard/reach-report/reach-report.component').then(
                (c) => c.ReachReportComponent
              )
          },
          {
            path: RequestMapper.REJECTION_REPORT,
            loadComponent: () =>
              import('./views/common/dashboard/rejection-report/rejection-report.component').then(
                (c) => c.RejectionReportComponent
              )
          },
          {
            path: RequestMapper.VISIT_REPORTS,
            loadComponent: () =>
              import('./views/common/dashboard/visit-report/visit-report.component').then(
                (c) => c.VisitReportComponent
              )
          },
          {
            path: RequestMapper.DP_ENTRY_STATS,
            loadComponent: () =>
              import('./views/common/dashboard/dp-entry-stats/dp-entry-stats.component').then(
                (c) => c.DpEntryStatsComponent
              )
          },
          {
            path: RequestMapper.DP_1_0_REPORT,
            loadComponent: () =>
              import('./views/common/dashboard/dp-1-o-report/dp-1-o-report.component').then(
                (c) => Dp1OReportComponent
              )
          },
          {
            path: RequestMapper.RITWIK_REPORT,
            // component: RitwikReportComponent
            loadComponent: () =>
              import('./views/common/dashboard/ritwik-report/ritwik-report.component').then(
                (c) => RitwikReportComponent
              )
          },
          {
             path: RequestMapper.USER_ACTIVITY_REPORT,
            // component: RitwikReportComponent
            loadComponent: () =>
              import('./views/common/dashboard/user-activity-report/user-activity-report.component').then(
                (c) => UserActivityReportComponent
              )

          }

        ],
      },
      {
        path: RequestMapper.OBLATE_REGISTER,
        component: OblateDataComponent,
        canActivate: [authGuard],
      },
      {
        path: RequestMapper.ADD_NEW_OBLATE_ONLINE,
        loadComponent: () =>
          import('./oblate-add-new/oblate-add-new.component').then(
            (c) => c.OblateAddNewComponent
          ),
      },
      {
        path: RequestMapper.LIST_DRAFT_OBLATE,
        loadComponent: () =>
          import('./oblate-draft-list-offline/oblate-draft-list-offline.component').then(
            (c) => c.OblateDraftListOfflineComponent
          )
      },
      {
        path: RequestMapper.EDIT_OFFLINE_DRAFT_OBLATE_DATA + '/:slno',
        loadComponent: () =>
          import('./oblate-add-new/oblate-add-new.component').then(
            (c) => c.OblateAddNewComponent
          )
      },
      {
        path: RequestMapper.ADD_NEW_OBLATE_OFFLINE,
        loadComponent: () =>
          import('./oblate-add-new/oblate-add-new.component').then(
            (c) => c.OblateAddNewComponent
          ),
      },
      {
        path: RequestMapper.DP_ENTRY,
        loadComponent: () =>
          import('./oblate-draft-list-offline/oblate-draft-list-offline.component').then(
            (c) => c.OblateDraftListOfflineComponent
          )
      },
      {
        path: 'point_of_contact',
        component: PointOfContactComponent,
        canActivate: [authGuard],
      },
      {
        path: RequestMapper.DP_SP_RECEIVING,
        component: DpSpReceivingComponent,
        canActivate: [authGuard],
        children: [
          {
            path: RequestMapper.DP_SP_RECEIVING_REPORT,
            loadComponent: () => import('./dp-sp-receiving-report/dp-sp-receiving-report.component').then(
              (c) => c.DpSpReceivingReportComponent
            ),
          },
        ]
      },
      {
        path: 'manage-user',
        component: ManageUserComponent,
        canActivate: [authGuard],
      },
      // {
      //   path: 'personal-info',
      //   component: PersonalInformationComponent,
      //   canActivate: [authGuard],
      // },
      {
        path: RequestMapper.UPDATE,
        component: UpdateMemberComponent,
        canActivate: [authGuard],
      },
      {
        path: RequestMapper.MERGE_FC_DATA,
        component: FcMergeComponent,
        canActivate: [authGuard],
      },
      // {
      //   path: RequestMapper.DEFAULTER,
      //   component: ReachDefaulterComponent,
      //   canActivate: [authGuard],
      // },
      {
        path: RequestMapper.PRINT_AND_MONITOR,
        component: PrintMonitorComponent,
        canActivate: [authGuard],
      },
      // {
      //   path: RequestMapper.PRINT_AND_MONITOR + '/:country' +
      //   '/:state',
      //   component: PrintMonitorComponent,
      // },
      // {
      //   path:
      //     RequestMapper.PRINT_AND_MONITOR +
      //     '/:country' +
      //     '/:state' +
      //     '/:district',
      //   component: PrintMonitorComponent,
      // },
      // {
      //   path:
      //     RequestMapper.PRINT_AND_MONITOR +
      //     '/:country' +
      //     '/:state' +
      //     '/:district/show-data',
      //   component: PrintMonitorComponent,
      // },
      // {
      //   path:
      //     RequestMapper.PRINT_AND_MONITOR +
      //     '/:country' +
      //     '/:state' +
      //     '/:district' +
      //     '/:pincode',
      //   component: PrintMonitorComponent,
      // },
      // {
      //   path:
      //     RequestMapper.PRINT_AND_MONITOR +
      //     '/:country' +
      //     '/:state' +
      //     '/:district' +
      //     '/:pincode/show-data',
      //   component: PrintMonitorComponent,
      // },
      {
        path: RequestMapper.DPNF_LIST,
        component: DpnfComponent,
        canActivate: [authGuard],
        children: [
          {
            path: '',
            redirectTo: RequestMapper.MY_DPNF_LIST,
            pathMatch: 'full',
          },

          {
            path: RequestMapper.MY_DPNF_LIST,
            loadComponent: () =>
              import(
                './views/common/dpnf/my-dpnf/my-dpnf.component'
              ).then((c) => c.MyDpnfComponent),
          },
          {
            path: RequestMapper.OTHERS_DPNF_LIST,
            loadComponent: () =>
              import(
                './views/common/dpnf/others-dpnf/others-dpnf.component'
              ).then((c) => c.OthersDpnfComponent),
          },
        ],
      },
      {
        path: RequestMapper.DEFAULTER_MAIN_ROUTE,
        // component: ReachDefaulterComponent,
        component: ReachDefaulterMainComponent,
        canActivate: [authGuard],
        children: [
          {
            path: '',
            redirectTo: RequestMapper.DEFAULTER,
            pathMatch: 'full',
          },

          {
            path: RequestMapper.DEFAULTER,
            loadComponent: () =>
              import(
                './reach-defaulter/defaulter-list/defaulter-list.component'
              ).then((c) => c.DefaulterListComponent),
          },
          {
            path: RequestMapper.REACHED,
            loadComponent: () =>
              import(
                './reach-defaulter/reached-list/reached-list.component'
              ).then((c) => c.ReachedListComponent),
          },
          {
            path: RequestMapper.RESTORED,
            loadComponent: () =>
              import(
                './reach-defaulter/restored-list/restored-list.component'
              ).then((c) => c.RestoredListComponent),
          },
        ],
      },
      {
        path: RequestMapper.MASTER_SEARCH,
        component: MasterSearchComponent,
        children: [
          {
            path: '',
            redirectTo: 'global-search',
            pathMatch: 'full',
          },
          {
            path: RequestMapper.ARE_YOU_UPDATED,
            loadComponent: () =>
              import(
                './master-search-group/are-you-updated/are-you-updated.component'
              ).then((c) => c.AreYouUpdatedComponent),
            canActivate: [authGuard],
          },
          {
            path: RequestMapper.NAME_SEARCH,
            loadComponent: () =>
              import(
                './master-search-group/name-search/name-search.component'
              ).then((c) => c.NameSearchComponent),
          },
          {
            path: RequestMapper.GLOBAL_SEARCH,
            loadComponent: () =>
              import(
                './master-search-group/global-search/global-search.component'
              ).then((c) => c.GlobalSearchComponent),
            canActivate: [authGuard],
          },
          {
            path: RequestMapper.KEYWORD_SEARCH,
            loadComponent: () =>
              import(
                './master-search-group/keyword-search/keyword-search.component'
              ).then((c) => c.KeywordSearchComponent),
            canActivate: [authGuard],
          },
        ],
      },

      {
        path: RequestMapper.REVIEW_DATA,
        component: ReviewDataComponent,
        children: [
          {
            path: '',
            redirectTo: RequestMapper.UPDATED_DATA,
            pathMatch: 'full',
          },
          // {

          //   path: '',
          //   redirectTo: RequestMapper.FC_MERGE_DATA,
          //   pathMatch: 'full',
          // },
          {
            path: RequestMapper.UPDATED_DATA,
            loadComponent: () =>
              import(
                './review-data-group/review-data/updated-data/updated-data.component'
              ).then((c) => c.UpdatedDataComponent),
          },
          {
            path: RequestMapper.SL_NO_MERGE,
            loadComponent: () =>
              import(
                './review-data-group/review-data/sl-no-merge-data/sl-no-merge-data.component'
              ).then((c) => c.SlNoMergeDataComponent),
          },
          {
            path: RequestMapper.MIGRATED_DATA,
            loadComponent: () =>
              import(
                './review-data-group/migrated-data/migrated-data.component'
              ).then((c) => c.MigratedDataComponent),
          },
          {
            path: RequestMapper.FC_MERGE_DATA,
            loadComponent: () =>
              import(
                './review-data-group/review-data/merge-fc-data/merge-fc-data.component'
              ).then((c) => c.MergeFcDataComponent),

            canActivate: [authGuard],
          },
        ],
      },
      {
        path: RequestMapper.NAMES_TO_UPDATE,
        component: NamesToUpdateComponent,
        canActivate: [authGuard],
      },
      {
        path: RequestMapper.DP_4_0,
        component: Dp40Component,
        canActivate: [authGuard],
      },
      {
        path: RequestMapper.FIND_DETAIL,
        component: FindDetailsMainComponent,
        children: [
          {
            path: '',
            redirectTo: RequestMapper.ASSIGNED_LIST,
            pathMatch: 'full',
          },

          {
            path: RequestMapper.ASSIGNED_LIST,
            loadComponent: () =>
              import(
                './find-details/assigned-list/assigned-list.component'
              ).then((c) => c.AssignedListComponent),
          },
          {
            path: RequestMapper.NOT_FOUND_LIST,
            loadComponent: () =>
              import(
                './find-details/not-found-list/not-found-list.component'
              ).then((c) => c.NotFoundListComponent),
          },
          {
            path: RequestMapper.TRANSFER_REQUEST,
            loadComponent: () =>
              import(
                './find-details/pending-requests/pending-requests.component'
              ).then((c) => c.PendingRequestsComponent),
          },
        ],
      },
      {
        path: RequestMapper.PROFILE,
        component: DpProfileComponent,
        canActivate: [authGuard],
      },
      {
        path: RequestMapper.SETTLEMENT_VIEW,
        component: SettlementViewComponent,
        canActivate: [authGuard],
      },
      {
        path: RequestMapper.WORK_HISTORY,
        component: WorkHistoryMainComponent,
        children: [
          // {
          //   path: '',
          //   redirectTo: WORK_UPDATE_ROUTER,
          //   pathMatch: 'full',
          // },

          {
            path: RequestMapper.WORK_UPDATE_HISTORY_DA,
            loadComponent: () =>
              import(
                './work-history/da-work-history/da-work-history.component'
              ).then((c) => c.DaWorkHistoryComponent),
          },
          {
            path: RequestMapper.SU_WORK_HISTORY,
            loadComponent: () =>
              import(
                './work-history/su-work-history/su-work-history.component'
              ).then((c) => c.SuWorkHistoryComponent),
          },

          {
            path: RequestMapper.WORK_UPDATE_HISTORY,
            loadComponent: () =>
              import('./work-history/work-history.component').then(
                (c) => c.WorkHistoryComponent
              ),
          },
          {
            path: RequestMapper.WORK_MERGE_HISTORY,
            loadComponent: () =>
              import(
                './work-history/work-history-merge/work-history-merge.component'
              ).then((c) => c.WorkHistoryMergeComponent),
          },
          {
            path: RequestMapper.MY_OBLATES,
            loadComponent: () =>
              import(
                './work-history/oblate-add-history/oblate-add-history.component'
              ).then((c) => c.OblateAddHistoryComponent),
          }
          // {
          //   path: RequestMapper.WORK_UPDATE_HISTORY_DA,
          //   loadComponent: () =>
          //     import(
          //       './work-history/da-work-history/da-work-history.component'
          //     ).then((c) => c.DaWorkHistoryComponent),
          // },
        ],
      },
      {
        path: RequestMapper.PANJA_INFO,
        component: PanjaDetailsComponent
      },
      {
        path: RequestMapper.RITWIKI,
        component: RitwikiComponent
      },

      {
        path: RequestMapper.PARIBHRITY,
        loadComponent: () =>
          import('./paribhriti/paribhriti.component').then((c) => c.ParibhritiComponent)
      },

      // {
      //   path: 'allWishlist',
      //   component: AllWishlistComponent,
      //   canActivate: [authGuard],
      // },
      {
        path: RequestMapper.OBLATE_DEVOTION,
        loadComponent: () =>
          import('./oblate-devotion/oblate-devotion.component').then((c) => c.OblateDevotionComponent)
      },

      {
        path: RequestMapper.IFIP,
        loadComponent: () =>
          import('./ifip/ifip.component').then((c) => c.IfipComponent),
        canActivate: [authGuard]
      }
    ],
  },
  {
    path: RequestMapper.LOGIN,
    component: LoginComponent,
  },

  {
    path: RequestMapper.CREATE_ACCOUNT,
    component: CreateAccountComponent,
  },
  {
    path: RequestMapper.LOGIN_AUTH_CODE,
    component: LoginVerifyComponent,
  },
  {
    path: RequestMapper.LOGIN_ROLE_MERGE,
    component: LoginRoleMergeComponent,
  },
  {
    path: RequestMapper.LOGIN_EMAIL_AUTH,
    component: LoginEmailAuthCodeComponent,
  },

  {
    path: RequestMapper.CREATE_ACCOUNT_VERIFICATION,
    component: CreateAccountVerificationComponent,
    canDeactivate: [UnsavedChangesGuard],
  },
  { path: RequestMapper.RESET_PASSWORD, component: ResetPasswordComponent },
  { path: '**', redirectTo: RequestMapper.PAGE_NOT_FOUND, pathMatch: 'full' },
];
